export * from './Pre.jsx'
import pre from './Pre.jsx'
import h2 from './H2.jsx'
import h3 from './H3.jsx'

export const mdxComponents = {
  pre,
  h2,
  h3
}

export default mdxComponents